export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={`flex items-center justify-center p-12 ${className ?? ""}`}
      role="status"
      aria-label="Loading"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
    </div>
  );
}
